"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsBySkus = void 0;
const routes_1 = require("../../routes");
const getProductsBySkus = (client) => async (query) => {
    const response = await client.post(routes_1.ENDPOINTS.GET_PRODUCTS_BY_SKUS.path, query);
    return response.data;
};
exports.getProductsBySkus = getProductsBySkus;
